import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";

export const ContainerDNUStatisticsSnapshotEntryValidator = t.intersection([
  t.type({
    dttm: t.number,
    count: t.number,
    total: t.number,
    pipelineCount: t.number,
    pipelineTotal: t.number,
  }),
  t.partial({}),
]);

export const ContainerDNUStatisticsSnapshotEntryArrayValidator = t.array(ContainerDNUStatisticsSnapshotEntryValidator);

export type ContainerDNUStatisticsSnapshotEntrySnapshotEntry = t.TypeOf<typeof ContainerDNUStatisticsSnapshotEntryValidator>;
export type ContainerDNUStatisticsSnapshotEntryArray = t.TypeOf<typeof ContainerDNUStatisticsSnapshotEntryArrayValidator>;

@Exclude()
export class ContainerDNUStatisticsSnapshotEntryEntity {
  @Expose()
  dttm!: number

  @Expose()
  count!: number

  @Expose()
  total!: number

  @Expose()
  pipelineCount!: number

  @Expose()
  pipelineTotal!: number

  /**
   * Constructor for ContainerDNUStatisticsSnapshotEntryEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(containerContainerDNUStatisticsSnapshotEntry: ContainerDNUStatisticsSnapshotEntrySnapshotEntry): ContainerDNUStatisticsSnapshotEntryEntity {
    return plainToInstance(
      ContainerDNUStatisticsSnapshotEntryEntity,
      containerContainerDNUStatisticsSnapshotEntry,
      {
        excludeExtraneousValues: true,
      }
    );
  }

  loadTypeValue(): Promise<ContainerDNUStatisticsSnapshotEntrySnapshotEntry> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ContainerDNUStatisticsSnapshotEntryValidator, object);
  }

  asTypeValue(): ContainerDNUStatisticsSnapshotEntrySnapshotEntry {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(ContainerDNUStatisticsSnapshotEntryValidator, object);
  }
}
